import React, { useEffect, useState } from "react";
import styles from "./../styles/PWAPrompt.style.css";
import ShareIcon from "./ShareIcon";
import HomeScreenIcon from "./HomeScreenIcon";

const InstallPWA = () => {
    const [modalOpen, setModalOpen] = useState(false);
    const visibilityClass = modalOpen ? 'visible' : 'hidden';
    const isiOS13AndUp = /OS (13|14)/.test(window.navigator.userAgent);
    const iOSClass = isiOS13AndUp ? 'modern' : "legacy";
    useEffect(
        () => {
            setModalOpen(true)
        }, []
    );
    const onTransitionOut = (evt) => {
        if (!modalOpen) {
            evt.currentTarget.style.display = "none";
        }
    };
    return (
        <>
            <div
                className={`pwaPromptOverlay ${visibilityClass} ${iOSClass} iOSPWA-overlay`}
                aria-label="Close"
                role="button"
                onClick={() => setModalOpen(false)}
                onTransitionEnd={onTransitionOut}
            />
            <div
                className={`pwaPrompt ${visibilityClass} ${iOSClass} iOSPWA-container`}
                aria-describedby="pwa-prompt-description"
                aria-labelledby="pwa-prompt-title"
                role="dialog"
                onTransitionEnd={onTransitionOut}
            >
                <div className={`pwaPromptHeader iOSPWA-header`}>
                    <p id="pwa-prompt-title" className={`pwaPromptTitle iOSPWA-title`} > Add to Home Screen</p>
                    <button className={`pwaPromptCancel iOSPWA-cancel`} onClick={() => setModalOpen(false)}>
                        Cancel
                    </button>
                </div>
                <div className={`pwaPromptBody iOSPWA-body`}>
                    <div className={`pwaPromptDescription iOSPWA-description`}>
                        <p id="pwa-prompt-description" className={`pwaPromptCopy iOSPWA-description-copy`}>
                            This website has app functionality. Add it to your home screen to use it in fullscreen.
                        </p>
                    </div>
                </div>
                <div className={`pwaPromptInstruction iOSPWA-steps`}>
                    <div className={`pwaPromptInstructionStep iOSPWA-step1`}>
                        <ShareIcon
                            className={`pwaPromptShareIcon iOSPWA-step1-icon`}
                            modern={isiOS13AndUp}/><p className={`pwaPromptCopy bold iOSPWA-step1-copy`}>1) Press the 'Share' button</p>
                    </div>
                    <div className={`pwaPromptInstructionStep iOSPWA-step2`}>
                        <HomeScreenIcon
                            className={`pwaPromptHomeIcon iOSPWA-step2-icon`}
                            modern={isiOS13AndUp}
                        />
                        <p className={`pwaPromptCopy ${styles.bold} iOSPWA-step2-copy`}>
                            2) Press 'Add to Home Screen'
                        </p>
                    </div>
                </div>
            </div>
        </>
    )
}

export default InstallPWA;